import React from 'react';

import { Tooltip } from '..';

interface Props {
    list: string[];
    tooltipPosition?: TooltipPosition;
    width?: number;
}

export const TruncatedList = ({
    list,
    tooltipPosition = 'right',
    width = 130,
}: Props): JSX.Element => {
    if (list === null || list.length === 0) {
        // unicode em dash
        return <>&#8212;</>;
    }

    const joinedList = list.join(', ');

    return (
        <Tooltip
            message={joinedList}
            position={tooltipPosition}
            minWidth={250}
            maxWidth={250}
        >
            <div
                className="respond-to-mouse truncate"
                style={{
                    width,
                }}
            >
                {joinedList}
            </div>
        </Tooltip>
    );
};
